import { Component, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { IAbstractView } from '@core/interfaces';
import { SwitchPresenter } from './switch.presenter';
import { ISwitchComponent, ISwitchPresenter } from './interfaces';
import { IconComponent } from '../icon/icon.component';

@Component({
	selector: 'app-switch-v2',
	templateUrl: './switch.component.html',
	styleUrls: ['./switch.component.scss'],
	imports: [CommonModule, IonicModule, IconComponent],
	providers: [SwitchPresenter],
	standalone: true,
})
export class SwitchComponent extends IAbstractView<ISwitchPresenter> implements ISwitchComponent {
	translations = this.presenter.translations;
	checked = this.presenter.checked;
	switchLabel = this.presenter.switchLabel;
	dinamicIcon = this.presenter.dinamicIcon;

	@Input() loading$ = this.presenter.loading$;
	@Input() onLabel = this.presenter.onLabel;
	@Input() offLabel = this.presenter.offLabel;
	@Input() offIcon = this.presenter.offIcon;
	@Input() onIcon = this.presenter.onIcon;
	@Input() disabled = this.presenter.disabled;
	@Output() changed = this.presenter.changed;

	@ViewChild('switchCustom') switchCustom = this.presenter.switchCustom;

	constructor(presenter: SwitchPresenter) {
		super(presenter);
	}

	onClick(): void {
		this.presenter.onClick();
	}

	getCheckedLabel(value: boolean): boolean {
		return this.presenter.getCheckedLabel(value);
	}
}
